import { Injectable } from '@angular/core';
import { ApiActions, UtilService } from '../common/util.service';
import { Subject } from 'rxjs';
import {
  ProductUOM,
  Postsetup,
  EquipmentMaster,
  ProcessParams,
  ProcessStep,
  BCItem,
  PostComments,
  User,
  Tags
} from 'src/app/model';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../common/app-config.service';
import { MsgService } from '../common/msg.service';
import { CommonDataService } from '../common/common-data.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PostsetupService {

  public pageName = 'Posts';
  public dataList = new Subject<Array<Postsetup>>();

  constructor(
    private http: HttpClient,
    private config: AppConfigService,
    private msgService: MsgService,
    private common: CommonDataService,
    private util: UtilService,
    private router:Router
  ) { }

  private getUrl(apiOption: ApiActions) {
    return this.config.ipAddress + this.config.PostsApi[apiOption];
  }

  public getProductsData() {
    const resultList = new Subject<Array<Postsetup>>();
    const url = this.config.ipAddress + this.config.ProductMasterApi[ApiActions.Get];
    this.http.post(url, null, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result && response.result.productList) {
          const list = response.result.productList.map(e => {
            //  tslint:disable-next-line: no-string-literal
            e['stdBatchSize'] = 0;
            return e;
          });
          resultList.next(list);
        }
      },
        err => {
            this.msgService.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
    return resultList;
  }

  public getPostComments(post_id: number): Subject<Array<PostComments>> {
    const url = this.config.ipAddress + this.config.PostCommentsApi[ApiActions.Get];
    const dataArray: Array<PostComments> = [];
    const fData = new FormData();
    fData.append('post_id', post_id + '');
    const data = new Subject<Array<PostComments>>();
    this.http.post(url, fData, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          response.result.PostComments.map(element => {
            element.status = Number(element.rec_status) === 1 ? true : false;
            dataArray.push(element);
          });
          data.next(dataArray);
        }
      },
        err => {
            this.msgService.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
    return data;
  }

  public getUsers(): Subject<Array<User>> {
    const url = this.config.ipAddress + this.config.userApi[ApiActions.Get];
    const dataArray: Array<User> = [];
    const data = new Subject<Array<User>>();
    this.http.post(url, null, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          response.result.userslist.map(element => {
            element.status = Number(element.rec_status) === 1 ? true : false;
            dataArray.push(element);
          });
          data.next(dataArray);
        }
      },
        err => {
            this.msgService.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
    return data;
  }

  public getauthors(): Subject<Array<User>> {
    const url = this.config.ipAddress + this.config.AuthorsApi[ApiActions.Get];
    const dataArray: Array<User> = [];
    const data = new Subject<Array<User>>();
    this.http.post(url, null, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          response.result.Authors.map(element => {
            element.status = Number(element.status) === 1 ? true : false;
            dataArray.push(element);
          });
          data.next(dataArray);
        }
      },
        err => {
            this.msgService.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
    return data;
  }


  public getDataRecords() {
    this.http.post(this.getUrl(ApiActions.Get), null, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          const dataArray: Array<Postsetup> = [];
          response.result.Posts.map(element => {
            element.status = element.status == '1' ? true : false;
            dataArray.push(element);
          });
          this.dataList.next(dataArray);
        }
      },
        err => {
            this.msgService.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
  }



  public getItemsList(post_id: number) {
    const url = this.config.ipAddress + this.config.PostsApi[ApiActions.Delete];
    const data = new Subject<Array<BCItem>>();
    const fData = new FormData();
    fData.append('post_id', post_id + '');
    this.http.post(url, fData, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          const result = response.result.PostComments;
          data.next(result);
        }
      },
        err => {
            this.msgService.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
    return data;
  }

  public getBookmarksList(post_id: number) {
    const url = this.config.ipAddress + this.config.PostsApi[ApiActions.GetSingle];
    const data = new Subject<Array<BCItem>>();
    const fData = new FormData();
    fData.append('post_id', post_id + '');
    this.http.post(url, fData, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result) {
          const result = response.result.postbookmarks;
          data.next(result);
        }
      },
        err => {
            this.msgService.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
    return data;
  }

  public getTags() {
    const resultList = new Subject<Array<Tags>>();
    let data = [];
    const url = this.config.ipAddress + this.config.TagsApi[ApiActions.Get];
    this.http.post(url, null, { headers: undefined })
      .subscribe((response: any) => {
        if (response && response.result && response.result.Tags) {
          data = response.result.Tags;
          resultList.next(data);
        }
      },
        err => {
            this.msgService.addErrorMsg({ summary: 'Login', detail: 'Token Expired Please Login Again.' });  setTimeout(() => { localStorage.clear();  this.router.navigate(['/account/login']); }, 1000);
        });
    return resultList;
  }

  public updateData(objData: Postsetup) {
    // objData.status = this.util.getSaveStatus();
    return this.Save(this.getUrl(ApiActions.Update), objData);
  }

  public saveDraft(objData: Postsetup) {
    // objData.status = this.util.getDraftStatus();
    return this.Save(this.getUrl(ApiActions.Create), objData);
  }

  private Save(action: string, objData: Postsetup) {
    const responseMsg = new Subject<string>();
    const fData = new FormData();
    // fData.append('status', objData.status + '');
    fData.append('post_id', objData.post_id + '');
    fData.append('post_title', objData.post_title);
    fData.append('short_desc', objData.short_desc);
    fData.append('long_desc', objData.long_desc);
    fData.append('post_likes', objData.post_likes);
    fData.append('post_attach', objData.post_attach);

    // const items = objData.items.map(e => {
    //   return {
    //     comment_desc: e.comment_desc,
    //     parent_id: e.parent_id,
    //     author_id: e.author_id
    //   };
    // });

    // const tagitems = objData.tagitems.map(e => {
    //   return {
    //     tag_id: e.tag_id
    //   };
    // });

    fData.append('tagitems', objData.tag_id);

    // fData.append('items', JSON.stringify(items));

    this.http.post(action, fData, { headers: undefined }).subscribe((response: any) => {
      if (response) {
        this.msgService.addSuccessMsg({ summary: this.pageName, detail: response.result.status });
        responseMsg.next('');
      }
    },
      err => {
        responseMsg.next(err);
      });

    return responseMsg;
  }

  public updatecommentData(itemObj: Postsetup) {
    // objData.status = this.util.getSaveStatus();
    return this.CommentSave(this.getUrl(ApiActions.GetUserPermissions), itemObj);
  }

  private CommentSave(action: string, itemObj: Postsetup) {
    const responseMsg = new Subject<string>();
    const fData = new FormData();
    // fData.append('status', objData.status + '');
    fData.append('post_id', itemObj.post_id + '');
    fData.append('comment_desc', itemObj.comment_desc);
    fData.append('parent_id', itemObj.parent_id + '');
    fData.append('author_id', itemObj.author_id + '');

    this.http.post(action, fData, { headers: undefined }).subscribe((response: any) => {
      if (response) {
        this.msgService.addSuccessMsg({ summary: this.pageName, detail: response.result.status });
        responseMsg.next('');
      }
    },
      err => {
        responseMsg.next(err);
      });

    return responseMsg;
  }

  public updateStatus(objData: Postsetup) {
    const fData = new FormData();
    fData.append('status', objData.status ? '1' : '0');
    fData.append('post_id', objData.post_id + '');
    return this.common.executeAction(fData, this.getUrl(ApiActions.UpdateStatus), this.pageName);
  }

  public deleteData(itemObj: Postsetup) {
    const fData = new FormData();
    fData.append('comment_id', itemObj.comment_id + '');
    return this.common.executeAction(fData, this.getUrl(ApiActions.GetTasks), this.pageName);
  }

}
